import { createRequestTypes } from '../../utils';

// ----------------------------------------------------------------------
// Action Types
// ----------------------------------------------------------------------

export const FETCH_ALERTS = createRequestTypes('FETCH_ALERTS');
export const FETCH_ALERT_DETAIL = createRequestTypes('FETCH_ALERT_DETAIL');
export const RESOLVE_ALERT = createRequestTypes('RESOLVE_ALERT');
export const DISMISS_ALERT = createRequestTypes('DISMISS_ALERT');
export const CREATE_ALERT = createRequestTypes('CREATE_ALERT');
export const MARK_ALERT_READ = createRequestTypes('MARK_ALERT_READ');
export const MARK_ALL_ALERTS_READ = createRequestTypes('MARK_ALL_ALERTS_READ');

export const SET_ALERT_FILTERS = 'SET_ALERT_FILTERS';
export const SET_SELECTED_ALERT = 'SET_SELECTED_ALERT';
export const CLEAR_ALERTS_FEEDBACK = 'CLEAR_ALERTS_FEEDBACK';
export const RESET_ALERTS_STATE = 'RESET_ALERTS_STATE';
export const MARK_ALERT_NOTIFIED_LOCALLY = 'MARK_ALERT_NOTIFIED_LOCALLY';
export const MARK_ALERT_EXPIRED_LOCALLY = 'MARK_ALERT_EXPIRED_LOCALLY';
export const REMOVE_ALERT_LOCALLY = 'REMOVE_ALERT_LOCALLY';
export const ACTIVATE_NEXT_RECURRENCE = createRequestTypes('ACTIVATE_NEXT_RECURRENCE');
export const FETCH_UNREAD_COUNT = createRequestTypes('FETCH_UNREAD_COUNT');
export const ADVANCE_BATCH_FROM_ALERT = createRequestTypes('ADVANCE_BATCH_FROM_ALERT');

// ----------------------------------------------------------------------
// Action Creators - List & Detail
// ----------------------------------------------------------------------

export const fetchAlertsRequest = (params = {}) => ({
  type: FETCH_ALERTS.REQUEST,
  payload: params,
});

export const fetchAlertsSuccess = (data, meta) => ({
  type: FETCH_ALERTS.SUCCESS,
  payload: { data, meta },
});

export const fetchAlertsFailure = (error) => ({
  type: FETCH_ALERTS.FAILURE,
  payload: error,
});

export const fetchAlertDetailRequest = (alertId) => ({
  type: FETCH_ALERT_DETAIL.REQUEST,
  payload: { alertId },
});

export const fetchAlertDetailSuccess = (data) => ({
  type: FETCH_ALERT_DETAIL.SUCCESS,
  payload: { data },
});

export const fetchAlertDetailFailure = (error) => ({
  type: FETCH_ALERT_DETAIL.FAILURE,
  payload: error,
});

// ----------------------------------------------------------------------
// Action Creators - Mutations
// ----------------------------------------------------------------------

export const resolveAlertRequest = (alertId) => ({
  type: RESOLVE_ALERT.REQUEST,
  payload: { alertId },
});

export const resolveAlertSuccess = (data) => ({
  type: RESOLVE_ALERT.SUCCESS,
  payload: { data },
});

export const resolveAlertFailure = (error) => ({
  type: RESOLVE_ALERT.FAILURE,
  payload: error,
});

export const dismissAlertRequest = (alertId) => ({
  type: DISMISS_ALERT.REQUEST,
  payload: { alertId },
});

export const dismissAlertSuccess = (data) => ({
  type: DISMISS_ALERT.SUCCESS,
  payload: { data },
});

export const dismissAlertFailure = (error) => ({
  type: DISMISS_ALERT.FAILURE,
  payload: error,
});

export const createAlertRequest = (payload) => ({
  type: CREATE_ALERT.REQUEST,
  payload,
});

export const createAlertSuccess = (data) => ({
  type: CREATE_ALERT.SUCCESS,
  payload: { data },
});

export const createAlertFailure = (error) => ({
  type: CREATE_ALERT.FAILURE,
  payload: error,
});

export const markAlertReadRequest = (alertId) => ({
  type: MARK_ALERT_READ.REQUEST,
  payload: { alertId },
});

export const markAlertReadSuccess = (data) => ({
  type: MARK_ALERT_READ.SUCCESS,
  payload: { data },
});

export const markAlertReadFailure = (error) => ({
  type: MARK_ALERT_READ.FAILURE,
  payload: error,
});

export const markAllAlertsReadRequest = () => ({
  type: MARK_ALL_ALERTS_READ.REQUEST,
});

export const markAllAlertsReadSuccess = (data) => ({
  type: MARK_ALL_ALERTS_READ.SUCCESS,
  payload: { data },
});

export const markAllAlertsReadFailure = (error) => ({
  type: MARK_ALL_ALERTS_READ.FAILURE,
  payload: error,
});

// Notification tracking
export const addNotifiedAlert = (alertId) => ({
  type: 'ADD_NOTIFIED_ALERT',
  payload: alertId,
});

export const removeNotifiedAlert = (alertId) => ({
  type: 'REMOVE_NOTIFIED_ALERT',
  payload: alertId,
});

// Popover alert list (for displaying triggered alerts in popover)
export const addToPopoverAlertList = (alert) => ({
  type: 'ADD_TO_POPOVER_ALERT_LIST',
  payload: alert,
});

export const removeFromPopoverAlertList = (alertId) => ({
  type: 'REMOVE_FROM_POPOVER_ALERT_LIST',
  payload: alertId,
});

export const clearPopoverAlertList = () => ({
  type: 'CLEAR_POPOVER_ALERT_LIST',
});

// ----------------------------------------------------------------------
// UI State
// ----------------------------------------------------------------------

export const setAlertFilters = (filters) => ({
  type: SET_ALERT_FILTERS,
  payload: filters,
});

export const setSelectedAlert = (alert) => ({
  type: SET_SELECTED_ALERT,
  payload: alert,
});

export const clearAlertsFeedback = () => ({
  type: CLEAR_ALERTS_FEEDBACK,
});

export const resetAlertsState = () => ({
  type: RESET_ALERTS_STATE,
});

export const markAlertNotifiedLocally = (alertId) => ({
  type: MARK_ALERT_NOTIFIED_LOCALLY,
  payload: alertId,
});

export const markAlertExpiredLocally = (alertId) => ({
  type: MARK_ALERT_EXPIRED_LOCALLY,
  payload: alertId,
});

export const removeAlertLocally = (alertId) => ({
  type: REMOVE_ALERT_LOCALLY,
  payload: alertId,
});

export const activateNextRecurrenceRequest = (alertId) => ({
  type: ACTIVATE_NEXT_RECURRENCE.REQUEST,
  payload: { alertId },
});

export const activateNextRecurrenceSuccess = (data) => ({
  type: ACTIVATE_NEXT_RECURRENCE.SUCCESS,
  payload: data,
});

export const activateNextRecurrenceFailure = (error) => ({
  type: ACTIVATE_NEXT_RECURRENCE.FAILURE,
  payload: error,
});

// Unread count
export const fetchUnreadCountRequest = () => ({
  type: FETCH_UNREAD_COUNT.REQUEST,
});

export const fetchUnreadCountSuccess = (count) => ({
  type: FETCH_UNREAD_COUNT.SUCCESS,
  payload: { count },
});

export const fetchUnreadCountFailure = (error) => ({
  type: FETCH_UNREAD_COUNT.FAILURE,
  payload: error,
});

// Advance batch from alert
export const advanceBatchFromAlertRequest = (alertId) => ({
  type: ADVANCE_BATCH_FROM_ALERT.REQUEST,
  payload: { alertId },
});

export const advanceBatchFromAlertSuccess = (data) => ({
  type: ADVANCE_BATCH_FROM_ALERT.SUCCESS,
  payload: { data },
});

export const advanceBatchFromAlertFailure = (error) => ({
  type: ADVANCE_BATCH_FROM_ALERT.FAILURE,
  payload: error,
});
